package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import se.mittpass.shared.api.*

class HrRepository(private val httpClient: HttpClient) {
    suspend fun getDocuments(workplaceId: Long): Result<List<HrDocumentDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/hr/documents").body()
    }
    suspend fun createDocument(workplaceId: Long, req: CreateHrDocumentRequest): Result<Unit> = runCatching {
        httpClient.post("workplaces/$workplaceId/hr/documents") { setBody(req) }
    }
    suspend fun deleteDocument(docId: Long): Result<Unit> = runCatching {
        httpClient.delete("hr/documents/$docId")
    }
    suspend fun getCertifications(workplaceId: Long): Result<List<CertificationDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/hr/certifications").body()
    }
    suspend fun createCertification(workplaceId: Long, req: CreateCertificationRequest): Result<Unit> = runCatching {
        httpClient.post("workplaces/$workplaceId/hr/certifications") { setBody(req) }
    }
    suspend fun deleteCertification(certId: Long): Result<Unit> = runCatching {
        httpClient.delete("hr/certifications/$certId")
    }
    suspend fun getChecklists(workplaceId: Long): Result<List<OnboardingChecklistDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/hr/checklists").body()
    }
    suspend fun createChecklist(workplaceId: Long, req: CreateChecklistRequest): Result<Unit> = runCatching {
        httpClient.post("workplaces/$workplaceId/hr/checklists") { setBody(req) }
    }
    suspend fun getOnboardingProgress(workplaceId: Long): Result<List<OnboardingProgressDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/hr/onboarding-progress").body()
    }
}
